import type {SVGProps} from 'react'
const DotsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    preserveAspectRatio="none"
    width="1em"
    height="1em"
    overflow="visible"
    style={{
      display: 'block',
    }}
    viewBox="0 0 12 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Outline">
      <path
        d="M2 1C2 1.55228 1.55228 2 1 2C0.447715 2 0 1.55228 0 1C0 0.447715 0.447715 0 1 0C1.55228 0 2 0.447715 2 1Z"
        fill="var(--fill-0, #2D2E2C)"
      />
      <path
        d="M7 1C7 1.55228 6.55228 2 6 2C5.44772 2 5 1.55228 5 1C5 0.447715 5.44772 0 6 0C6.55228 0 7 0.447715 7 1Z"
        fill="var(--fill-0, #2D2E2C)"
      />
      <path
        d="M11 2C11.5523 2 12 1.55228 12 1C12 0.447715 11.5523 0 11 0C10.4477 0 10 0.447715 10 1C10 1.55228 10.4477 2 11 2Z"
        fill="var(--fill-0, #2D2E2C)"
      />
    </g>
  </svg>
)
export {DotsIcon}
